import React, { useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  DialogContentText,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useIntl } from "react-intl";
import { AjaxBlackout, createSnackbar, Flex, Loading } from "../../../../_common";

ModalReiniciarCiclo.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  leads: PropTypes.array,
  callback: PropTypes.func,
  etapas: PropTypes.arrayOf(
    PropTypes.shape({
      funil: PropTypes.shape({
        id: PropTypes.number.isRequired,
        nome: PropTypes.string.isRequired,
      }).isRequired,
      nome: PropTypes.string.isRequired,
    })
  ),
  funilId: PropTypes.number,
};

export default function ModalReiniciarCiclo({ id, leads, funilId, etapas, callback = () => null }) {
  const [funil, setFunil] = React.useState();
  const intl = useIntl();

  useEffect(
    () => {
      if (etapas && etapas.length === 1) {
        setFunil(etapas[0].funil.id.toString());
      }
    },
    [etapas]
  );

  async function reiniciarCiclo(funilIdDestino) {
    AjaxBlackout.Show();
    try {
      const { data: success } = await axios.post(
        `/api/pipeline/lead/reiniciarCiclo?id=${id}&funilId=${funilIdDestino}`
      );
      callback(success);
    } catch (e) {
      callback(false);
    } finally {
      AjaxBlackout.Hide();
    }
  }

  async function reiniciarCicloEmMassa(funilIdDestino) {
    AjaxBlackout.Show();
    try {
      await axios.post("/api/pipeline/lead/EnviarParaReiniciarCiclo", {
        leadIds: leads.map(lead => lead.id),
        funilId: funilIdDestino,
      });
      createSnackbar(intl.formatMessage({ defaultMessage: "Operação realizada com sucesso" }));
      callback(true);
    } catch (e) {
      createSnackbar(intl.formatMessage({ defaultMessage: "Não foi possível reinicar o ciclo dos leads" }));
      callback(false);
    } finally {
      AjaxBlackout.Hide();
    }
  }

  return (
    <Fragment>
      <DialogTitle>
        {leads.length > 1
          ? intl.formatMessage({ defaultMessage: "Reiniciar ciclo" })
          : intl.formatMessage({ defaultMessage: "Reiniciar ciclo do lead" })}
      </DialogTitle>
      <DialogContent>
        {etapas.length === 1 ? (
          <>
            <DialogContentText>
              {intl.formatMessage({
                defaultMessage:
                  "Ao reiniciar o ciclo do lead, seu ciclo será alterado e ele voltará à primeira etapa do funil",
              })}
            </DialogContentText>
            <DialogContentText>
              {intl.formatMessage({ defaultMessage: "Deseja reiniciar o ciclo do lead?" })}
            </DialogContentText>
          </>
        ) : (
          <>
            <DialogContentText>
              {leads.length > 1
                ? intl.formatMessage({
                    defaultMessage:
                      "Os leads selecionados terão seu ciclo reiniciado. Escolha abaixo a etapa de destino",
                  })
                : intl.formatMessage({ defaultMessage: "Selecione a etapa destino do lead" })}
            </DialogContentText>
            <Loading isLoading={!etapas}>
              <div>
                {etapas.map(etapaDestino => (
                  <Flex justifyContent="flex-start" alignItems="center" key={etapaDestino.funil.id}>
                    <FormControlLabel
                      value={etapaDestino.funil.id?.toString()}
                      control={<Radio />}
                      label={
                        etapaDestino.funil.id === funilId
                          ? `${etapaDestino.funil.nome} - ${etapaDestino.nome} (${intl.formatMessage({
                              defaultMessage: "Atual",
                            })})`
                          : `${etapaDestino.funil.nome} - ${etapaDestino.nome}`
                      }
                      checked={funil === etapaDestino.funil.id.toString()}
                      onChange={event => setFunil(event.target.value)}
                    />
                  </Flex>
                ))}
              </div>
            </Loading>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => callback(false)} id="cancelar-reiniciar-ciclo">
          {intl.formatMessage({ defaultMessage: "Cancelar" })}
        </Button>
        <Button
          onClick={id ? reiniciarCiclo.bind(this, funil) : reiniciarCicloEmMassa.bind(this, funil)}
          color="primary"
          id="confirmar-reiniciar-ciclo"
          disabled={!funil && leads.length > 1}
        >
          {intl.formatMessage({ defaultMessage: "Reiniciar ciclo" })}
        </Button>
      </DialogActions>
    </Fragment>
  );
}
